import { useSearchParams } from 'react-router-dom';
import { NavBarSiteSearchParamsValues } from './Index';
import { ExternalNavLinks } from './ExternalNavLinks';

export const ExternalNavMakeLinkPage = (path) => {
    const leftLinks = ExternalNavLinks()
    const [searchParams, setSearchParams] = useSearchParams();

    for (let i = 0; i < leftLinks.length; i++) {
        const leftLink = leftLinks[i];
        if (leftLink.path == path) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set(NavBarSiteSearchParamsValues.nav_value, leftLink.id); // atualiza ou adiciona o parâmetro
            return `${path}/?${newParams.toString()}`
        }
    }
    return path
}

